import { NgModule } from '@angular/core';
import { SignupComponent } from './signup/signup.component';
import { SigninComponent } from './signin/signin.component';
import { SigninPageComponent } from './signin-page/signin-page.component';
import { CustomSharedModule } from '../shared/shared.module'
import { AccountRoutingModule } from './account-routing.module'

import { RequestResetComponent } from "./reset/request.reset.component";
import { ResetComponent } from "./reset/reset.component";

@NgModule({
  imports: [
    CustomSharedModule,
    AccountRoutingModule
  ],
  declarations: [
    SigninComponent,
    SignupComponent,
    RequestResetComponent,
    SigninPageComponent,
    ResetComponent
  ],
  exports: [
    SigninComponent,
    SignupComponent,
    RequestResetComponent,
    SigninPageComponent,
    ResetComponent
  ]
})
export class AccountModule { }



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/account.module.ts